export default "__VITE_ASSET__7vjsdawZ__"